import { render } from "./MyCompanies.vue?vue&type=template&id=5a1cb5f1&scoped=true"
import script from "./MyCompanies.vue?vue&type=script&lang=js"
export * from "./MyCompanies.vue?vue&type=script&lang=js"

import "./MyCompanies.vue?vue&type=style&index=0&id=5a1cb5f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1cb5f1"]])

export default __exports__